import { CreateQuestionnairePage } from './CreateQuestionnairePage';
export default CreateQuestionnairePage;